// extracted by mini-css-extract-plugin
export default {"loginHeading":"POCI7Jh6kd3t2w3_d90N","headingWrapper":"ETaswT5ncpkoUc6yF9Ia","subTitle":"e2OL8lmllFQKlil4NCRO"};